/**
 * Full-width Continue with Google CTA for Login / Register (Google-first auth).
 */
import React from "react";
import PropTypes from "prop-types";
import { TvButton, TvDiv, TvPath, TvSvg } from "@trustvid/design-system";
import { AUTH_GOOGLE_SSO_COPY } from "./loginPageContent";

const GoogleMark = () => (
  <TvSvg
    className="tv-login-page__google-mark"
    width="18"
    height="18"
    viewBox="0 0 48 48"
    aria-hidden="true"
    focusable="false"
    data-testid="auth-google-mark"
  >
    <TvPath
      className="tv-login-page__google-mark-yellow"
      d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.2 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.5-.4-3.5z"
    />
    <TvPath
      className="tv-login-page__google-mark-red"
      d="M6.3 14.7l6.6 4.8C14.7 16 19 12 24 12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.2 6.1 29.3 4 24 4 16.3 4 9.6 8.3 6.3 14.7z"
    />
    <TvPath
      className="tv-login-page__google-mark-green"
      d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.2 26.7 36 24 36c-5.3 0-9.7-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z"
    />
    <TvPath
      className="tv-login-page__google-mark-blue"
      d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4.1 5.6l.1.1 6.2 5.2C39.2 37.3 44 32.5 44 24c0-1.3-.1-2.5-.4-3.5z"
    />
  </TvSvg>
);

const AuthGoogleSsoButton = ({ testId, enabled = false, disabled = false, onClick }) => (
  <TvDiv className="d-grid mb-3">
    <TvButton
      type="button"
      color="light"
      className="tv-login-page__google-sso"
      disabled={!enabled || disabled}
      data-testid={testId}
      onClick={onClick}
    >
      <GoogleMark />
      {enabled ? AUTH_GOOGLE_SSO_COPY.continueWithGoogle : AUTH_GOOGLE_SSO_COPY.continueWithGoogleComingSoon}
    </TvButton>
  </TvDiv>
);

AuthGoogleSsoButton.propTypes = {
  testId: PropTypes.string.isRequired,
  enabled: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default AuthGoogleSsoButton;
